import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { STAT_EVENT } from '@/global/config'
import store from '@/store'
import * as Types from '@/store/types'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 返回 savedPosition，在按下 后退/前进 按钮时，就会像浏览器的原生表现那样
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    // 页面切换时需要返回顶部
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const { name, query } = to
  const { fr } = query
  if (fr) {
    const date = new Date()
    date.setDate(date.getDate() + 1)
    document.cookie = `fr=${fr}; expires=${date.toGMTString()}; path=/`
  }

  let currentRefer = window.referrer || document.referrer || ''
  // 更新window.refer(当前url)
  if (!from.path || from.path === '/') {
    window.referrer = currentRefer
  } else {
    window.referrer = document.location.origin + from.fullPath
  }

  const { user } = store.state
  if (!user.userInfo) {
    store.dispatch(`user/${[Types.GET_USER]}`).then(() => {
      store.commit(`stats/${[Types.UPDATE_STAT_INFO]}`, user.userInfo.uid)
      // 页面展示埋点
      // key都使用路由配置中name+'_show'
      const key = `${name}_show`
      // 埋点配置项存在才进行埋点
      if (STAT_EVENT[key]) {
        store.dispatch(`stats/${Types.ADD_STAT}`, {
          key,
          params: { a: 'show' },
          pathName: to.name
        })
      }
    })
  }
  next()
})

export default router
